module.exports = __webpack_public_path__ + "img/benefits_srb.3e682cd4.jpg";